import { NegotiationStatus } from "@/api/types";
import { cn } from "@/lib/utils";

export type MeetingsFilter = "all" | NegotiationStatus;

const OPTIONS: { value: MeetingsFilter; label: string }[] = [
  { value: "all",       label: "All" },
  { value: "ACCEPTED",  label: "Confirmed" },
  { value: "OPEN",      label: "Pending" },
  { value: "FAILED",    label: "Failed" },
  { value: "EXPIRED",   label: "Expired" },
  { value: "CANCELLED", label: "Cancelled" },
];

export function MeetingsFilterChips({
  current,
  onChange,
}: {
  current: MeetingsFilter;
  onChange: (f: MeetingsFilter) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={cn(
            "rounded-full border px-3 py-1 font-display text-[11px] font-semibold uppercase tracking-wide transition-colors",
            current === o.value
              ? "border-transparent bg-primary text-primary-foreground shadow-sm"
              : "border-border bg-card text-muted-foreground hover:bg-muted hover:text-foreground",
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
